import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ContainerInput, InputDate, CloseIcon, MiddleText, ContainerText } from './styles';

export default ({
  date,
  setDate,
  endDate,
  setEndDate,
  handleStatus,
  closeIcon = true,
  showRange = false,
  minEndDate,
  dropdownPicker,
}: {
  date: Date;
  setDate: Function;
  endDate?: Date;
  setEndDate?: any;
  handleStatus?: any;
  closeIcon?: boolean;
  showRange?: boolean;
  minEndDate?: Date;
  dropdownPicker?: boolean;
}) => {
  return (
    <ContainerInput>
      <InputDate>
        <DatePicker
          selected={date}
          startDate={date}
          popperPlacement={'bottom'}
          onChange={date => setDate(date)}
          endDate={showRange ? endDate : undefined}
          selectsStart={showRange}
          showMonthDropdown={dropdownPicker ? true : false}
          showYearDropdown={dropdownPicker ? true : false}
        />
      </InputDate>
      {endDate && (
        <>
          <ContainerText>
            <MiddleText> TO </MiddleText>
          </ContainerText>
          <InputDate>
            <DatePicker
              selectsEnd
              selected={endDate}
              popperPlacement={'bottom'}
              startDate={showRange ? date : undefined}
              endDate={showRange ? endDate : undefined}
              minDate={minEndDate ? minEndDate : undefined}
              onChange={endDate => setEndDate(endDate)}
              showMonthDropdown={dropdownPicker ? true : false}
              showYearDropdown={dropdownPicker ? true : false}
            />
          </InputDate>
        </>
      )}
      {closeIcon && (
        <CloseIcon onClick={handleStatus} color={'rgba(93,110,129,1)'} size={'25px'} />
      )}
    </ContainerInput>
  );
};
